export default "__VITE_ASSET__Cflbgh_R__"